import { Injectable } from '@angular/core';

import { AccountBalanceLoggerService } from '@frontend/sports/account-balance/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { EditBetActions } from '../../edit-bet/actions';
import { BetslipOverAskActions } from '../../over-ask/actions';
import { QuickBetActions } from '../../quick-bet/quick-bet-actions';
import { BetslipTeaserBetPlaceBetActions } from '../../teaser-bet/place-bet.actions';
import { BetslipPlaceBetActions } from '../actions';

@Injectable()
export class PlaceBetLoggerEffects {
    constructor(
        private actions$: Actions,
        private logger: AccountBalanceLoggerService,
    ) {}

    freezeBalanceLogsDuringPlacement$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(
                    BetslipPlaceBetActions.placeBet,
                    BetslipOverAskActions.placeBet,
                    QuickBetActions.placeBet,
                    BetslipTeaserBetPlaceBetActions.placeBet,
                    EditBetActions.placeBet,
                ),
                tap((_) => this.logger.freezeLogWhilePlacement()),
            );
        },
        { dispatch: false },
    );
}
